import React from 'react'

const SkillCard = ({title, description, image,bgColor}) => {
  return (
    <div className="skill-card">
      <div className="skill-card-image" style={{backgroundColor: bgColor}}>
        <img src={image} alt={title} />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  )
}

export default SkillCard
